import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import "./landing.css";

const isAdmin = (role) => role === "super_admin" || role === "admin";
const homeFor = (role) => (isAdmin(role) ? "/dashboard" : "/projects");

const FEATURES = [
  {
    title: "AI Project Manager",
    body: "Define goals, budget, KPIs, audience and timeline in a guided wizard before a single dollar is spent.",
  },
  {
    title: "Claude marketing strategy",
    body: "Turn your plan into an execution-ready strategy — funnel, budget split, creative and a 90-day roadmap.",
  },
  {
    title: "Google + Meta analytics",
    body: "Live campaign performance across both platforms, unified into one dashboard.",
  },
  {
    title: "Versioning & approvals",
    body: "Every strategy is versioned with an approval workflow, notes, files and a full activity trail.",
  },
];

export default function LandingPage() {
  const { user, isAuthed } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="lp">
      <header className="lp-nav">
        <div className="lp-logo">
          <span className="logo-mark" />
          <span>AdIntel AI</span>
        </div>
        <nav className="lp-nav-actions">
          {isAuthed ? (
            <button className="lp-btn lp-btn-primary" onClick={() => navigate(homeFor(user.role))}>
              Open app
            </button>
          ) : (
            <>
              <Link className="lp-link" to="/login">
                Sign in
              </Link>
              <Link className="lp-btn lp-btn-primary" to="/login">
                Get started
              </Link>
            </>
          )}
        </nav>
      </header>

      <section className="lp-hero">
        <span className="lp-eyebrow">AI-powered advertising intelligence</span>
        <h1>
          Plan smarter campaigns,<br />
          <span className="lp-grad">before you spend.</span>
        </h1>
        <p className="lp-sub">
          AdIntel AI turns your business goals into an execution-ready Google &amp; Meta marketing
          strategy — planned, generated and tracked in one place.
        </p>
        <div className="lp-cta">
          {isAuthed ? (
            <button className="lp-btn lp-btn-primary lp-btn-lg" onClick={() => navigate(homeFor(user.role))}>
              Open the app
            </button>
          ) : (
            <>
              <Link className="lp-btn lp-btn-primary lp-btn-lg" to="/login">
                Get started free
              </Link>
              <Link className="lp-btn lp-btn-ghost lp-btn-lg" to="/login">
                Sign in
              </Link>
            </>
          )}
        </div>
      </section>

      <section className="lp-features">
        {FEATURES.map((f) => (
          <div key={f.title} className="lp-feature">
            <h3>{f.title}</h3>
            <p>{f.body}</p>
          </div>
        ))}
      </section>

      <section className="lp-flow">
        <h2>From goal to strategy in minutes</h2>
        <div className="lp-steps">
          {["Create a project", "Complete the 8-step wizard", "Generate AI strategy", "Approve & track"].map(
            (s, i) => (
              <div key={s} className="lp-step">
                <span className="lp-step-num">{i + 1}</span>
                <span>{s}</span>
              </div>
            )
          )}
        </div>
      </section>

      <footer className="lp-footer">
        <span>© {new Date().getFullYear()} AdIntel AI</span>
        {!isAuthed && (
          <Link className="lp-link" to="/login">
            Sign in
          </Link>
        )}
      </footer>
    </div>
  );
}
